import { CSS } from '@grupoboticario/flora-react'

export const dotCss: CSS = {
  width: '$1',
  height: '$6',
  borderRadius: '$large'
}

export const textCss: CSS = {
  color: 'inherit'
}

export const getDotWithColorCss = (color: string): CSS => ({
  ...dotCss,
  backgroundColor: color
})

export const getTextColorCss = (color: string): CSS => ({
  color
})
